import { useTranslation } from "react-i18next";
import { CreateQuestionMultiple } from "./QuestionMultiple";
import { CreateQuestionProgressPictureBody } from "./QuestionProgressPictures";
import { CreateQuestionScaleBody } from "./QuestionScale";
import { CreateQuestionShortBody } from "./QuestionShort";
import { CreateQuestionOptions } from "./QuestionCreateOptions";

const QuestionCreateBody = ({ data, setData }) => {
  const { t } = useTranslation("athlete-portal");
  const renderBody = () => {
    const { type, body: rawBody } = data;
    const body = rawBody ?? {
      description: t("questionTypeDefaults.shortDescription"),
    };

    const componentMap = {
      short: CreateQuestionShortBody,
      bodyweight: CreateQuestionShortBody,
      nutrition: CreateQuestionShortBody,
      scale: CreateQuestionScaleBody,
      progress: CreateQuestionProgressPictureBody,
      multiple: CreateQuestionMultiple,
      checkbox: CreateQuestionMultiple,
      steps: CreateQuestionShortBody,
      sleep: CreateQuestionShortBody,
      hrv: CreateQuestionShortBody,
      measurement: CreateQuestionOptions,
    };

    const Component = componentMap[type] || CreateQuestionShortBody;
    const placeholder =
      body.description || t("questionTypeDefaults.shortDescription");
    const safeData = { ...data, body };

    return (
      <Component
        key={`body-${type}`}
        data={safeData}
        setData={setData}
        type={body.type}
        placeholder={placeholder}
      />
    );
  };

  return renderBody();
};

export default QuestionCreateBody;
